<div>
  <mat-form-field
    class="c-input"
    [ngClass]="{'remove-subtext': !errorsTemplate && !hint, readonly: readonly}"
    appearance="outline"
    style="width: 100%"
    [subscriptSizing]="subscriptSizing"
  >
    <mat-label>{{ label }}</mat-label>
    <mat-chip-grid
      [formControl]="chipsCtrl"
      [disabled]="form.disabled"
      #chipGrid
      aria-label="Chips selection"
    >
      <mat-chip-row
        *ngFor="let chip of chips$ | async"
        [editable]="false"
        [removable]="true"
        (removed)="remove(chip)"
      >
        {{ chip }}
        <ax-icon matChipRemove class="icon" name="close"></ax-icon>
      </mat-chip-row>
    </mat-chip-grid>
    <input
      matChipInputAddOnBlur
      [axDisableSpecialFileCharacters]="disableSpecialFileCharacters"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [readonly]="readonly"
      (matChipInputTokenEnd)="add($event)"
    />
    <mat-hint class="hint" align="end">
      {{ hint }}
    </mat-hint>
    <mat-error *ngIf="errorsTemplate">
      <ng-template [ngTemplateOutlet]="errorsTemplate"></ng-template>
    </mat-error>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (chip of filteredChips$ | async; track chip) {
        <mat-option [value]="chip">{{ chip }}</mat-option>
      }
    </mat-autocomplete>

    <button
      axButton
      icon-button
      type="button"
      *ngIf="form?.enabled && hasValue && !readonly"
      matSuffix
      (click)="clearValue()"
    >
      <ax-icon class="icon" name="close"></ax-icon>
    </button>
  </mat-form-field>
</div>
